import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    currentPublisher: null,
  },
  actions: {
    fetchUserProfile(/*{ commit, state }*/) {
      // fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
      //     commit('setUserProfile', res.data())
      // }).catch(err => {
      //     console.log(err)
      // })
    },
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val;
    },
    setUserProfile(state, val) {
      state.userProfile = val;
    },
    setCurrentPublisher(state, val) {
      state.currentPublisher = val;
    },
  },
});

export default store;
